import { GlobeAltIcon as HeroGlobeAltIcon } from '@heroicons/react/24/outline';
export const GlobeAltIcon = HeroGlobeAltIcon;
